module.exports = __webpack_public_path__ + "static/media/CB_engagement_21.acb75268.jpg";